/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_Replace_All_ToastInputs */

const en_find_replace_replace_all_toast = /** @type {(inputs: Find_Replace_Replace_All_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All results replaced successfully`)
};

const fr_find_replace_replace_all_toast = /** @type {(inputs: Find_Replace_Replace_All_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les resultats ont ete remplaces avec succes`)
};

const de_find_replace_replace_all_toast = /** @type {(inputs: Find_Replace_Replace_All_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Ergebnisse wurden erfolgreich ersetzt.`)
};

const it_find_replace_replace_all_toast = /** @type {(inputs: Find_Replace_Replace_All_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i risultati sono stati sostituiti con successo`)
};

const ru_find_replace_replace_all_toast = /** @type {(inputs: Find_Replace_Replace_All_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все результаты успешно заменены.`)
};

const es_find_replace_replace_all_toast = /** @type {(inputs: Find_Replace_Replace_All_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los resultados fueron reemplazados exitosamente`)
};

const zh_cn2_find_replace_replace_all_toast = /** @type {(inputs: Find_Replace_Replace_All_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有结果均已成功替换。`)
};

const ja_find_replace_replace_all_toast = /** @type {(inputs: Find_Replace_Replace_All_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての結果が正常に置き換えられました`)
};

const hi_find_replace_replace_all_toast = /** @type {(inputs: Find_Replace_Replace_All_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी परिणाम सफलतापूर्वक बदल दिए गए।`)
};

const pt_pt2_find_replace_replace_all_toast = /** @type {(inputs: Find_Replace_Replace_All_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os resultados foram substituídos com sucesso.`)
};

/**
* | output |
* | --- |
* | "All results replaced successfully" |
*
* @param {Find_Replace_Replace_All_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_replace_all_toast = /** @type {((inputs?: Find_Replace_Replace_All_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Replace_All_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_find_replace_replace_all_toast(inputs)
	if (locale === "de") return de_find_replace_replace_all_toast(inputs)
	if (locale === "it") return it_find_replace_replace_all_toast(inputs)
	if (locale === "ru") return ru_find_replace_replace_all_toast(inputs)
	if (locale === "es") return es_find_replace_replace_all_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_find_replace_replace_all_toast(inputs)
	if (locale === "ja") return ja_find_replace_replace_all_toast(inputs)
	if (locale === "hi") return hi_find_replace_replace_all_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_find_replace_replace_all_toast(inputs)
	return en_find_replace_replace_all_toast(inputs)
});